<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="orders"
      class="font-class"
      resource="orders"
    >
      <el-table-column
        prop="no"
        align="center"
        label="订单号"
        min-width="11%"
        show-overflow-tooltip
      />
      <el-table-column
        prop="area_name"
        align="center"
        label="区域"
        min-width="6%"
        show-overflow-tooltip
      />
      <el-table-column
        prop="bike_no"
        align="center"
        label="车牌号"
        min-width="6%"
        show-overflow-tooltip
      />
      <el-table-column
        prop="mobile"
        align="center"
        label="手机号"
        show-overflow-tooltip
        min-width="6%"
      />
      <el-table-column
        prop="real_use_bike_time_length"
        align="center"
        min-width="5%"
        label="骑行时长"
        show-overflow-tooltip
      />
      <el-table-column
        prop="order_total_money"
        align="center"
        min-width="5%"
        label="交易金额"
      />
      <el-table-column
        prop="pay_type_name"
        align="center"
        min-width="6%"
        label="交易方式"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.pay_type==1">{{ scope.row.pay_type_name }}</el-tag>
          <el-tag
            v-else
            type="warning"
          >{{ scope.row.pay_type_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="orders_status"
        align="center"
        label="订单状态"
        min-width="5%"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status==3"
            type="success"
          >{{ scope.row.orders_status }}</el-tag>
          <el-tag
            v-else-if="scope.row.status==4"
            type="info"
          >{{ scope.row.orders_status }}</el-tag>
          <el-tag
            v-else-if="scope.row.status==2"
            type="warning"
          >{{ scope.row.orders_status }}</el-tag>
          <el-tag
            v-else
            type="danger"
          >{{ scope.row.orders_status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="start_use_bike_time"
        label="开始时间"
        min-width="8%"
        show-overflow-tooltip
      />
      <el-table-column
        prop="end_use_bike_time"
        label="结束时间"
        min-width="8%"
        show-overflow-tooltip
      />
      <el-table-column
        prop="remark"
        label="备注"
        min-width="8%"
      >
        <template #default="{ row }">
          <input-edit
            :id="row.id"
            field="remark"
            :update="updateOrderRent"
            v-model="row.remark"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="12%"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="detailsClick(scope.row)"
          >详情</el-button>

          <el-button
            v-if="scope.row.status=='3' && scope.row.is_return"
            type="info"
            @click="returnMoneyClick(scope.row,scope.$index)"
            size="mini"
          >
            返还
          </el-button>
          <el-button
            v-else-if="scope.row.status=='2'"
            type="warning"
            @click="settlementMoneyClick(scope.row,scope.$index)"
            size="mini"
          >
            结算
          </el-button>

          <el-button
            v-show="scope.row.status=='1' "
            type="danger"
            @click="ejectCloseBike(scope.row,scope.$index)"
            size="mini"
          >
            还车
          </el-button>
          <el-button
            v-if="scope.row.status=='2' && scope.row.is_huisu"
            type="danger"
            @click="ejectReturnOrderBike(scope.row,scope.$index)"
            size="mini"
          >
            订单回溯
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="提示"
      :visible.sync="dialogCloseBikeVisible"
      width="30%"
    >
      <h2 style="color:red;">确认关闭此订单，并锁车吗</h2>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogCloseBikeVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="closeOrderClick()"
        >确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="详情"
      :visible.sync="detailsDialogVisible"
      width="70%"
      top="5vh"
    >
      <div class="info-body">
        <div
          class="info-wrpp"
          style="width:25%;"
        >
          <p class="info-title">订单详情</p>
          <div class="info-item"><span>订单号：</span> <span>{{ order_no }}</span></div>
          <div class="info-item"><span>车牌号：</span> <span>{{ bike_no }}</span></div>
          <div class="info-item"><span>区域：</span> <span>{{ area }}</span></div>
          <div class="info-item"><span>手机号码：</span> <span>{{ mobile }}</span></div>
          <div class="info-item"><span>订单状态：</span> <span>{{ order_status }}</span></div>
          <div class="info-item"><span>创建时间：</span> <span>{{ start_use_time }}</span></div>
          <div class="info-item"><span>结束时间：</span> <span>{{ end_use_time }}</span></div>
        </div>
        <div
          class="info-wrpp"
          style="width:25%;"
        >
          <div class="info-title">结算信息</div>
          <div class="info-item"><span>结算方式：</span> <span>{{ settle_type }} </span></div>
          <div class="info-item"><span>骑行时长：</span> <span>{{ real_use_bike_time_length_name }} </span></div>
          <div class="info-item"><span>骑行里程：</span> <span>{{ ridding_length }} 千米</span></div>
          <div class="info-item"><span>订单总金额：</span> <span class="amount">{{ order_total_money }} </span>元</div>
          <div class="info-item">
            <span>交易金额：</span><span class="amount">{{ order_total_money }}</span>元
            <div class="cost">
              <p class="resetwid"><span class="inline-span">基础租金：</span><span class="amountt">{{ rent_money }}</span> <span>元</span> </p>
              <p><span>租用超时花费：</span> <span class="amountt">{{ time_money }}</span> 元</p>
              <p><span>非还车点调度费：</span> <span class="amountt">{{ dispatch_money }}</span> 元</p>
            </div>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:28%;"
        >
          <p class="info-title">操作车辆记录</p>
          <div class="table-class">
            <el-table
              :data="tableData1"
              style="width: 100%"
            >
              <el-table-column
                prop="created_at"
                label="时间"
                align="center"
                width="180"
              />
              <el-table-column
                prop="name"
                label="操作"
                align="center"
                show-overflow-tooltip
              />
            </el-table>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:16%;margin-right:0;"
        >
          <p class="info-title">车辆控制</p>
          <div
            class="table-class"
            style="height:300px;text-align:center;"
          >
            <p>
              <el-button
                type="success"
                @click="orderBikeContro(order_no,'huiDian')"
              >超出运营区域回电</el-button>
            </p>
            <p>
              <el-button
                type="warning"
                @click="orderBikeContro(order_no,'openLock')"
              >　　车辆开锁　　</el-button>
            </p>
            <p>
              <el-button
                type="danger"
                @click="orderHuiSu()"
              >电量过低订单回溯</el-button>
            </p>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:32%"
        >
          <p class="info-title">订单消费记录</p>
          <div
            class="table-class"
            style="height:300px;"
          >
            <el-table
              :data="tableData2"
              style="width: 100%"
            >
              <el-table-column
                prop="created_at"
                label="时间"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                prop="name"
                label="操作"
                align="center"
                width="150"
                show-overflow-tooltip
              />
              <el-table-column
                prop="status"
                label="状态"
                align="center"
                width="80"
              >
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.status ==1"
                    type="success"
                  >成功</el-tag>
                  <el-tag
                    v-else
                    type="danger"
                  >失败</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:32%"
        >
          <p class="info-title">手机信息</p>
          <div
            class="table-class"
            style="height:300px;"
          >
            <el-table
              :data="tableData3"
              style="width: 100%"
            >
              <el-table-column
                prop="label"
                label="类型"
                align="center"
                width="150"
                show-overflow-tooltip
              />
              <el-table-column
                prop="value"
                label="数据值"
                align="center"
                show-overflow-tooltip
              />
            </el-table>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:32%;margin-right:0;"
        >
          <p class="info-title">位置详情 <span
              class="info-huanche"
              v-show="is_whole_area_huanche"
            >(运营区域内均可还车)</span></p>
          <div class="amap-page-container">
            <el-amap
              ref="map"
              vid="amapDemo"
              :amap-manager="amapManager"
              :center="center"
              :zoom="zoom"
              :plugin="plugin"
              :events="events"
              class="amap-demoo"
            >
              <el-amap-circle
                v-for="(circle,index) in circles"
                :key="'info2-'+index"
                :center="circle.center"
                :radius="circle.radius"
                :fill-opacity="circle.fillOpacity"
                :stroke-opacity="circle.strokeOpacity"
                :events="circle.events"
              />
              <el-amap-polygon
                v-for="(polygon, index) in polygons"
                :key="`parking_${index}`"
                :vid="index"
                :editable="false"
                :ref="`polygon_${index}`"
                :path="polygon.path"
                :z-index="40"
                :draggable="polygon.draggable"
                :fill-opacity="polygon.fillOpacity"
                :events="polygon.events"
              />
              <!-- <el-amap-circle
                  v-for="(circle,index) in banCircles"
                  :key="'info2s-'+index"
                  :center="circle.center"
                  :radius="circle.radius"
                  :fill-opacity="circle.fillOpacity"
                  :fill-color="circle.fillColor"
                  :stroke-color="circle.strokeColor"
                  :stroke-opacity="circle.strokeOpacity"
                  :events="circle.events"
                /> -->
              <el-amap-polygon
                v-for="(polygon, index) in banPolygons"
                :key="`parkings_${index}`"
                :vid="index"
                :editable="false"
                :ref="`polygon_${index}`"
                :path="polygon.path"
                :z-index="40"
                :draggable="polygon.draggable"
                :stroke-color="polygon.strokeColor"
                :fill-color="polygon.fillColor"
                :fill-opacity="polygon.fillOpacity"
                :events="polygon.events"
              />
              <el-amap-polygon
                v-for="(polygon, index) in polygonsarea"
                :key="'infopolygonsarea-'+index"
                :vid="index"
                :ref="`polygon_${index}`"
                :path="polygon.path"
                :fill-opacity="polygon.fillOpacity"
                :draggable="polygon.draggable"
                :events="polygon.events"
              />
              <el-amap-marker
                :position="markerOrderPosition.position"
                :events="markerOrderPosition.events"
                :visible="markerOrderPosition.visible"
                :draggable="markerOrderPosition.draggable"
                :icon="markerOrderPosition.icon"
              />
              <el-amap-marker
                :position="markerBikePosition.position"
                :events="markerBikePosition.events"
                :visible="markerBikePosition.visible"
                :draggable="markerBikePosition.draggable"
                :animation="markerBikePosition.animation"
                :icon="markerBikePosition.icon"
              />
            </el-amap>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:100%;margin-right:0;height:150px"
        >
          <p class="info-title">区域配置信息</p>
          <div
            class="table-class"
            style="padding-left:30px"
          >
            <p>
              骑行费用：日租模式，全天车辆基础租金金额为 <span class="span-red">{{ form.day_rent_money }}</span>元，日租可用时长为<span class="span-red">{{ form.day_rent_hours }}</span>小时，
              在一天内（即24小时内）租用时长超过此时长，每一小时收取<span class="span-red">{{ form.per_hours_day_rent_timeout_money }}</span>元。<span class="span-red">{{ form.day_rent_capping_money }}</span>元封顶。
            </p>
            <p>
              调度费用：当用户不在指定区域还车时，
              <span class="span-red">{{ form.min_limit_km }}</span>千米内，另收 <span class="span-red">{{ form.min_dispatching_fee }}</span> 元调度费，<span class="span-red">{{ form.min_limit_km }}</span>千米外，每增加<span class="span-red">{{ form.over_limit_per_km }}</span>千米，多收取<span class="span-red">{{ form.over_limit_per_km_money }}</span>元
              最高封顶 <span class="span-red">{{ form.max_dispatching_fee }}</span> 元，
              <span class="p-green">注意：最高封顶为0元时，表示无封顶</span>
            </p>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="返还"
      :visible.sync="returnDialogVisible"
      width="23%"
    >
      <div class="return-money">
        <p>
          <span> 返还基础租金:</span>
          <el-input
            v-model="returnMoneyForm.base_rent_money"
            @input="returnBaseRentMoney"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
            style="width:120px"
          />
          <span style="margin-left:20px">小等于￥{{ rent_money }}</span>
        </p>
        <p>
          <span> 返还骑行费用:</span>
          <el-input
            v-model="returnMoneyForm.ridding_money"
            @input="returnRiddingMoney"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
            style="width:120px"
          />
          <span style="margin-left:20px">小等于￥{{ time_money }}</span>
        </p>
        <p>
          <span> 返还调度费用:</span>
          <el-input
            v-model="returnMoneyForm.dispatch_money"
            @input="returnDispatchMoney"
            style="width:120px"
          />
          <span style="margin-left:20px">小等于￥{{ dispatch_money }}</span>
        </p>
        <p>
          <span>
            选择返还方式：
          </span>
          <el-radio
            v-model="returnMoneyForm.return_type"
            label="wallet"
          >平台余额</el-radio>
          <el-radio
            v-model="returnMoneyForm.return_type"
            label="wechat"
          >微信</el-radio>
        </p>
        <p>
          <span>实际支付:</span> <span class="font-span"> {{ pay_money }}</span>
        </p>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="returnDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitReturnMoney"
        >确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="结算"
      :visible.sync="settlementDialogVisible"
      width="23%"
    >
      <div class="return-money">
        <p>
          <span> 基础租金:</span>
          <el-input
            v-model="settlementMoneyForm.rent_money"
            @input="settlementRentMoney"
            style="width:200px"
          />
        </p>
        <p>
          <span> 骑行费用:</span>
          <el-input
            v-model="settlementMoneyForm.ridding_money"
            @input="settlementRiddingMoney"
            style="width:200px"
          />
        </p>
        <p>
          <span> 调度费用:</span>
          <el-input
            v-model="settlementMoneyForm.dispatch_money"
            @input="settlementDispatchMoney"
            style="width:200px"
          />
        </p>
        <p>
          <span>实际支付:</span> <span class="font-span"> {{ settlementMoneyForm.pay_money }}</span>
        </p>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="settlementDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitSettlementMoney"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogReturnOrderBikeVisible"
      width="30%"
    >
      <h2 style="color:red;">确认回退此订单，改为骑车中吗</h2>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogReturnOrderBikeVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="changeOrderRidingBike()"
        >确 定</el-button>
      </span>
    </el-dialog>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import {
  getOrderRent,
  getOrderRentStatus,
  getOrderRentBikeOperate,
  closeLock,
  returnOrderMoney,
  settlementOrderRent,
  updateOrderRent,
  getOrderRentLocation,
  orderRentDetailPosition,
  changeRentOrderRiding,
  BikeControByOrderRent
} from "@/api/order-rent";
import { getAreas, showArea } from "@/api/area";
import VueAMap from "vue-amap";
import { getParkings } from "@/api/parking";
import InputEdit from "@c/quick-edit/InputEdit";
import { mixinsAutoPageSize } from "@/libs/utils";
import env from "../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination,
    InputEdit
  },
  data() {
    let self = this;
    let amapManager = new VueAMap.AMapManager();
    return {
      tableData1: [],
      tableData2: [],
      tableData3: [],
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "status",
          label: "订单状态",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "operate_status",
          label: "车辆操作状态",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },

        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        },
        {
          field: "no",
          label: "订单号"
        },
        {
          field: "bike_no",
          label: "车牌号"
        },
        {
          type: "time-between",
          field: "created_time_between",
          label1: "订单创建-开始",
          label2: "订单创建-结束"
        },
        {
          field: "remark",
          label: "备注"
        },
        {
          type: "el-select",
          field: "is_dispatch_money",
          label: "是否有调度费",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: "1",
              name: "有调度费"
            },
            {
              id: "2",
              name: "无调度费"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_refund_money",
          label: "是否返还费用",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: "1",
              name: "是"
            },
            {
              id: "0",
              name: "否"
            }
          ]
        }
      ],
      form: {},
      orders: [],
      page: null,
      detailsDialogVisible: false,
      order_no: "",
      order_id: "",
      bike_no: "",
      nickname: "",
      area: "",
      mobile: "",
      order_status: "",
      start_use_time: "",
      time_money: "",
      rent_money: "",
      sumRentMoney: "", // 计算的基础租金差值
      end_use_time: "",
      real_use_bike_time_length: "",
      real_use_bike_time_length_name: "",
      ridding_time: "",
      ridding_length: "",
      pay_money: "",
      order_total_money: "",
      pay_money_yun: "",
      sumDispatch: "", // 计算的调度差值
      dispatch_money: "",
      returnDialogVisible: false,
      dialogCloseBikeVisible: false,
      row_order_id: "",
      settle_type: "",
      returnMoneyForm: {
        // 返还表单数据
        return_type: "wallet",
        order_id: "",
        base_rent_money: 0,
        ridding_money: 0,
        dispatch_money: 0
      },
      returnMoneyFormBool: false,
      settlementDialogVisible: false,
      settlementIndex: "",
      returnIndex: "",
      settlementMoneyForm: {
        // 结算表单数据
        order_id: "",
        rent_money: "",
        ridding_money: 0,
        dispatch_money: 0,
        pay_money: ""
      },
      zoom: 15,
      lng: 0,
      lat: 0,
      center: [121.59996, 31.197646],
      amapManager: amapManager,
      events: {
        init(o) {}
      },
      plugin: [
        {
          pName: "MapType",
          defaultType: 0,
          events: {
            init(o) {
              // console.log(o)
            }
          }
        },
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              // console.log(o)
              o.getCurrentPosition((status, result) => {
                // 未配置https  定位失败 暂时手动配置
                self.lng = 113.73350255780726;
                self.lat = 34.78024666564106;
                // self.center = [self.lng, self.lat]
                self.loaded = true;
                if (result && result.position) {
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  // self.center = [self.lng, self.lat]
                  self.loaded = true;
                  self.$nextTick();
                }
              });
            }
          }
        },
        {
          pName: "Scale",
          // offset: { x: 20, y: 20 },
          position: "RB",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        },
        {
          pName: "ToolBar",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        }
      ],
      markerOrderPosition: {
        position: [121.5273285, 31.21515044],
        events: {
          click: () => {
            // alert('click marker')
          }
        },
        visible: true,
        draggable: false,
        icon:
          "http://resource.bike.hanyiyun.com/admin/zhongdian20191203141105.png"
      },
      markerBikePosition: {
        position: [121.5273285, 31.21515044],
        events: {
          click: () => {
            // alert('click marker')
          }
        },
        visible: true,
        draggable: false,
        animation: "AMAP_ANIMATION_DROP",
        icon: "http://resource.bike.hanyiyun.com/common/using.admin.png"
      },
      pathData: [],
      pathDataTimes: [],
      pathMarks: [],
      is_whole_area_huanche: false, // 能否全大区还车

      circles: [],
      polygons: [],
      banPolygons: [],
      banCircles: [],
      polygonsarea: [
        // 运营骑行区域
        {
          draggable: false,
          path: [],
          fillOpacity: 0.1,
          events: {
            click: () => {}
          }
        }
      ],
      dialogReturnOrderBikeVisible: false,
      first_blood: true
    };
  },
  mixins: [mixinsAutoPageSize],

  watch: {
    $route: {
      async handler(newVal) {
        // eslint-disable-next-line promise/param-names
        // let formHeight = await this.a()
        // console.log(formHeight)
        await this.autoPageSize(49, newVal);
        const {
          data: { data, meta }
        } = await getOrderRent(newVal.query);
        this.orders = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  inject: ["reload"],
  async created() {
    const [{ data: areas }, { data: orderStatus }] = await Promise.all([
      getAreas({ all: 1 }),
      getOrderRentStatus()
    ]);
    this.search[0].options.push.apply(this.search[0].options, areas);
    this.search[1].options.push.apply(
      this.search[1].options,
      orderStatus.order_status
    );
    this.search[2].options.push.apply(
      this.search[2].options,
      orderStatus.order_operate_status
    );
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[10].options.push.apply(
          this.search[10].options,
          merchant.data
        );
      }
    } 
  },
  methods: {
    updateOrderRent,
    async detailsClick(row) {
      // 订单详情
      this.detailsDialogVisible = true;
      this.order_no = row.no;
      this.order_id = row.id;
      this.bike_no = row.bike_no;
      this.nickname = row.nickname;
      this.area = row.area_name;
      this.mobile = row.mobile;
      this.order_status = row.orders_status;
      this.start_use_time = row.start_use_bike_time;
      this.end_use_time = row.end_use_bike_time;
      this.pay_money = row.pay_money;
      this.order_total_money = row.order_total_money;
      this.time_money = row.time_money;
      this.rent_money = row.rent_money;
      this.dispatch_money = row.dispatch_money;
      this.ridding_time = row.real_use_bike_time_length;
      this.ridding_length = row.use_bike_distance_length;
      this.settle_type = row.settle_type;
      this.real_use_bike_time_length_name = row.real_use_bike_time_length_name;

      if (row.phone_detail != "") {
        this.tableData3 = JSON.parse(row.phone_detail);
      } else {
        this.tableData3 = [];
      }
      const { data: orderBikeOperate } = await getOrderRentBikeOperate({
        order_id: row.id
      });
      this.tableData1 = orderBikeOperate.orderRentBikeOperate;
      this.tableData2 = orderBikeOperate.walletLogs;
      const { data: orderPositions } = await orderRentDetailPosition({
        order_id: row.id
      });

      this.markerOrderPosition.position = orderPositions.orderPosition;
      this.markerBikePosition.position = orderPositions.bikePosition;
      this.is_whole_area_huanche = orderPositions.is_whole_area_huanche;
      this.center = orderPositions.orderPosition;
      this.initParking(row.area_id);

      const { data: orderRentLocations } = await getOrderRentLocation({
        order_id: row.id
      });

      let _this = this;
      let OrderLocation = orderRentLocations.orderLocations;
      this.pathDataTimes = orderRentLocations.locationsTimes;
      if (OrderLocation.length == 0) {
        this.pathMarks = [];
        this.$message("此订单暂无轨迹");
        if (window.pathSimplifierIns) {
          pathSimplifierIns.setData([]);
          pathSimplifierIns.clearPathNavigators();
        }
      } else {
        let i = parseInt(OrderLocation.length / 2);
        // console.log(i)
        let centre = OrderLocation[i];
        // this.center = centre
        this.zoom = 20;
        this.pathData = OrderLocation;
        this.pathMarks = [];

        if (window.pathSimplifierIns) {
          // 去除轨迹
          pathSimplifierIns.setData([]);

          // 去除巡航器
          pathSimplifierIns.clearPathNavigators();
        }
        AMapUI.load(["ui/misc/PathSimplifier"], function(PathSimplifier) {
          if (!PathSimplifier.supportCanvas) {
            alert("当前环境不支持 Canvas！");
            return;
          }

          // 启动页面
          _this.initPage(PathSimplifier);
        });
      }
    },
    fillForm(data) {
      this.form.id = data.id;
      this.form.per_minute = data.per_minute;
      this.form.per_money = data.per_money;
      this.form.min_dispatching_fee = data.min_dispatching_fee;
      this.form.max_dispatching_fee = data.max_dispatching_fee;
      this.form.power_lower = data.power_lower;
      this.form.is_parking = data.is_parking.toString();
      this.form.is_advance_recharge = data.is_advance_recharge.toString();
      this.form.is_whole_area_huanche = data.is_whole_area_huanche.toString();
      this.form.is_parking_fushe = data.is_parking_fushe.toString();
      this.form.is_deposit = data.is_deposit.toString();
      this.form.deposit = data.deposit;
      this.form.is_auto_return_deposit = data.is_auto_return_deposit.toString();
      this.form.is_open_day_rent = data.is_open_day_rent.toString();
      this.form.is_return_deposit_ad_video = data.is_return_deposit_ad_video.toString();
      this.form.day_rent_money = data.day_rent_money;
      this.form.day_rent_hours = data.day_rent_hours;
      this.form.per_hours_day_rent_timeout_money =
        data.per_hours_day_rent_timeout_money;
      this.form.day_rent_capping_money = data.day_rent_capping_money;
      this.form.day_rent_img = data.day_rent_img;
      this.form.over_limit_per_km = data.over_limit_per_km;
      this.form.min_limit_km = data.min_limit_km;
      this.form.over_limit_per_km_money = data.over_limit_per_km_money;
      this.form.many_minute_free = data.many_minute_free;
      this.form.minute_free_times = data.minute_free_times;
      this.form.is_minute_free = data.is_minute_free.toString();
      this.form.starting_price_time = data.starting_price_time;
      this.form.starting_price = data.starting_price;
    },
    async initParking(areaId) {
      // 渲染骑行区
      // console.log(areaId)
      const [{ data: darea }] = await Promise.all([showArea(areaId)]);
      // this.center = JSON.parse(darea.area_centre)
      // this.zoom = 15
      this.fillForm(darea.areaSetting);
      var is_parking_fushe = darea.areaSetting.is_parking_fushe;
      this.polygonsarea[0].path = JSON.parse(darea.area_fence);
      // 取出此区域的停车区
      const { data: parkings } = await getParkings({
        type: 2,
        area_id: areaId,
        status: 1
      });

      let polygons = [];
      let circles = [];

      // 所有停车区遍历显示
      parkings.forEach((item, i) => {
        item.parking_centre = JSON.parse(item.parking_centre);

        polygons.push({
          draggable: false,
          strokeOpacity: 0.1,
          fillOpacity: 0.1,
          path: item.parking_fence,
          events: {
            change: () => {},
            click: () => {}
          }
        });

        circles.push({
          center: item.parking_centre,
          radius: item.parking_radius,
          fillOpacity: 0.1,
          events: {
            click: () => {
              // alert('click')
            }
          }
        });
      });

      if (is_parking_fushe == 1) {
        this.circles = circles;
      }
      this.polygons = polygons;

      // 取出此区域的禁停车区
      const [{ data: banData }] = await Promise.all([
        getParkings({ type: 1, area_id: areaId, status: 1 })
      ]);
      let banPolygons = [];
      let banCircles = [];
      var BanDatas = banData; // 所有停车区遍历显示
      BanDatas.forEach((item, i) => {
        item.parking_centre = JSON.parse(item.parking_centre);

        banPolygons.push({
          draggable: false,
          strokeOpacity: 0.1,
          fillOpacity: 0.3,
          fillColor: "red",
          strokeColor: "red",
          path: item.parking_fence,
          events: {
            change: () => {},
            click: () => {}
          }
        });

        banCircles.push({
          center: item.parking_centre,
          radius: item.parking_radius,
          fillOpacity: 0.3,
          fillColor: "red",
          strokeColor: "red",
          events: {
            click: () => {
              // alert('click')
            }
          }
        });
      });
      this.banCircles = banCircles;
      this.banPolygons = banPolygons;
    },
    initPage(PathSimplifier) {
      let _this = this;
      // 创建组件实例
      var pathSimplifierIns = new PathSimplifier({
        zIndex: 100,
        map: this.amapManager._map, // 所属的地图实例
        autoSetFitView: false,
        getPath: function(pathData, pathIndex) {
          // 返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
          return pathData.path;
        },
        getHoverTitle: function(pathData, pathIndex, pointIndex) {
          // console.log(_this.pathDataTimes)
          // 返回鼠标悬停时显示的信息
          if (pointIndex >= 0) {
            // 鼠标悬停在某个轨迹节点上
            return (
              pathData.name +
              "，点:" +
              pointIndex +
              "/" +
              pathData.path.length +
              ",时间：" +
              _this.pathDataTimes[pointIndex]
            );
          }
          // 鼠标悬停在节点之间的连线上
          return pathData.name + "，点数量" + pathData.path.length;
        },
        renderOptions: {
          // 轨迹线的样式
          pathLineStyle: {
            strokeStyle: "red",
            lineWidth: 2,
            dirArrowStyle: true
          },
          renderAllPointsIfNumberBelow: 100
        }
      });
      pathSimplifierIns.renderLater([{ delay: 1000 }]);
      window.pathSimplifierIns = pathSimplifierIns;

      // 这里构建两条简单的轨迹，仅作示例
      pathSimplifierIns.setData([
        {
          name: "轨迹",
          path: this.pathData
        }
      ]);

      // 创建一个巡航器
      var navg0 = pathSimplifierIns.createPathNavigator(
        0, // 关联第1条轨迹
        {
          loop: true, // 循环播放
          speed: 500
        }
      );

      navg0.start();
    },
    returnMoneyClick(row, index) {
      // 点击返还事件
      this.returnIndex = index;
      this.returnDialogVisible = true;
      this.pay_money = Number(row.total_money);
      this.pay_money_yun = Number(row.total_money); // 实际支付金额
      this.dispatch_money = row.dispatch_money;
      this.rent_money = row.rent_money;
      this.time_money = row.time_money;
      // 初始化返还表单数据
      this.returnMoneyForm.ridding_money = 0;
      this.returnMoneyForm.dispatch_money = 0;
      this.returnMoneyForm.order_id = row.id;
    },
    settlementMoneyClick(row, index) {
      // 结算点击事件
      this.settlementIndex = index;
      this.settlementDialogVisible = true;
      this.settlementMoneyForm.pay_money = Number(row.total_money);
      this.settlementMoneyForm.dispatch_money = Number(row.dispatch_money);
      this.settlementMoneyForm.ridding_money = Number(row.time_money);
      this.settlementMoneyForm.rent_money = Number(row.rent_money);
      this.settlementMoneyForm.order_id = row.id;
    },
    ejectCloseBike(row, index) {
      this.row_order_id = row.id;
      this.dialogCloseBikeVisible = true;
      // console.log(this.row_order_id)
    },
    async closeOrderClick() {
      await closeLock({ order_id: this.row_order_id }).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.reload();
            this.dialogCloseBikeVisible = false;
          }
        });
      });
    },
    returnRiddingMoney() {
      // 返还骑行金额输入事件
      this.pay_money =
        this.pay_money_yun -
        this.returnMoneyForm.ridding_money -
        this.returnMoneyForm.dispatch_money -
        this.returnMoneyForm.base_rent_money;
      if (this.pay_money < 0) {
        this.$message({
          message: "返还骑行金额不能大于实际支付金额",
          type: "warning"
        });
      }
    },
    returnBaseRentMoney() {
      this.pay_money =
        this.pay_money_yun -
        this.returnMoneyForm.ridding_money -
        this.returnMoneyForm.dispatch_money -
        this.returnMoneyForm.base_rent_money;

      // 返还基础租金
      if (this.returnMoneyForm.base_rent_money - this.rent_money < 0) {
        this.$message({
          message: "返还基础租金不能大于" + this.rent_money,
          type: "warning"
        });
      }
    },
    returnDispatchMoney() {
      //  返还调度金额输入事件
      this.pay_money =
        this.pay_money_yun -
        this.returnMoneyForm.dispatch_money -
        this.returnMoneyForm.ridding_money -
        this.returnMoneyForm.base_rent_money;
      //   if (this.pay_money < 0) {
      //     this.$message({
      //       message: '返还调度金额不能大于实际支付金额',
      //       type: 'warning',
      //     })
      //   }
      this.sumDispatch =
        this.dispatch_money - this.returnMoneyForm.dispatch_money;
      if (this.sumDispatch < 0) {
        this.$message({
          message: "返还调度金额不能大于" + this.dispatch_money,
          type: "warning"
        });
      }
    },
    async submitReturnMoney() {
      // 提交返还表单
      if (this.pay_money < 0) {
        this.$message({
          message: "返还金额不能大于实际支付金额",
          type: "warning"
        });
      } else if (this.sumDispatch < 0) {
        this.$message({
          message: "返还调度金额不能大于" + this.dispatch_money,
          type: "warning"
        });
      } else {
        this.returnMoneyFormBool = true;
      }
      if (this.returnMoneyFormBool) {
        await returnOrderMoney(this.returnMoneyForm).then(res => {
          res.then(data => {
            if (data) {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.orders[this.returnIndex].order_total_money = this.pay_money;
              this.reload();
            }
          });
        });
        this.returnDialogVisible = false;
      }
    },
    settlementRiddingMoney() {
      // 输入结算骑行费用事件
      this.settlementMoneyForm.pay_money =
        Number(this.settlementMoneyForm.ridding_money) +
        Number(this.settlementMoneyForm.dispatch_money) +
        Number(this.settlementMoneyForm.rent_money);
    },
    settlementDispatchMoney() {
      // 输入结算调度费用事件
      this.settlementMoneyForm.pay_money =
        Number(this.settlementMoneyForm.ridding_money) +
        Number(this.settlementMoneyForm.dispatch_money) +
        Number(this.settlementMoneyForm.rent_money);
    },
    settlementRentMoney() {
      this.settlementMoneyForm.pay_money =
        Number(this.settlementMoneyForm.ridding_money) +
        Number(this.settlementMoneyForm.dispatch_money) +
        Number(this.settlementMoneyForm.rent_money);
    },
    async submitSettlementMoney() {
      // 提交结算表单
      await settlementOrderRent(this.settlementMoneyForm).then(res => {
        res
          .then(data => {
            if (data) {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.orders[this.settlementIndex].status = 3;
              this.orders[this.settlementIndex].orders_status = "已完成";
              this.reload();
            }
          })
          .catch(err => {
            // console.log(err)
            this.reload();
          });
      });
    },
    ejectReturnOrderBike(row, index) {
      this.row_order_id = row.id;
      this.dialogReturnOrderBikeVisible = true;
    },
    async changeOrderRidingBike() {
      // 订单回溯
      await changeRentOrderRiding({ order_id: this.row_order_id }).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.reload();
            this.dialogReturnOrderBikeVisible = false;
          }
        });
      });
    },
    async orderHuiSu() {
      // 电量过低订单回溯
      await changeRentOrderRiding({
        order_id: this.order_id,
        is_low_electric: true
      }).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.reload();
            this.dialogReturnOrderBikeVisible = false;
          }
        });
      });
    },
    async orderBikeContro(no, type) {
      // console.log(no)
      // console.log(type)

      await BikeControByOrderRent({ order_no: no, type: type }).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.reload();
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.font-class {
  font-size: 12px;
  text-align: center;
}
.info-body {
  color: #606266;
  width: 100%;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .info-wrpp {
    width: 47%;
    margin: 10px 10px 20px 0;
    padding-bottom: 10px;
    background-color: #eee;
    .info-item {
      margin-bottom: 10px;
      :first-child {
        display: inline-block;
        width: 100px;
        text-align: right;
      }
      span :last-child {
        padding-left: 10px;
      }
      .amount {
        font-size: 18px;
        color: coral;
        margin-right: 5px;
      }
      .amountt {
        color: coral;
      }
      .cost {
        padding-left: 102px;
        padding-top: 8px;
        .resetwid {
          width: auto;
        }
        p {
          margin: 0;
          .inline-span {
            display: inline;
          }
          span {
            display: inline;
          }
        }
      }
    }
  }
}
.info-title {
  font-weight: 700;
  font-size: 16px;
  margin: 20px 0 20px;
  padding-left: 10px;
  color: #606266;

  .info-huanche {
    color: red;
    font-size: 13px;
  }
}
.table-class {
  margin: 10px;
  height: 300px;
  overflow: auto;
}
.return-money {
  margin: 10px auto 10px 30px;
  p {
    margin-bottom: 20px;
    span:first-child {
      display: inline-block;
      text-align: right;
      margin: 10px 10px;
      font-size: 16px;
      color: #606266;
      font-weight: 700;
    }
    .font-span {
      padding-left: 30px;
      font-size: 18px;
      color: blue;
      font-weight: 700;
    }
  }
}
.span-red {
  color: red;
  padding-left: 3px;
  padding-right: 3px;
}
.amap-demoo {
  height: 300px;
  margin: auto 10px;
}
</style>
